export const hiddenBannerLocales = new Set([
  'es-AR',
  'en-CA',
  'fr-CA',
  'es-CL',
  'es-CO',
  'en-HK',
  'es-MX',
  'en-NZ',
  'en-SG',
  'en-TH',
]);
